(function () {
    const initCrossref = {
        init: function () {
            initCrossref.controller();
        },
        controller: function () {
            var SETTINGS = {
                ENDPOINT: 'https://crossmark.crossref.org/dialog',
                SCRIPT_VERSION: 'v2.0',
                // LOGO_URL: 'http://crossmark-cdn.crossref.org/widget/v2.0/logos/crossmark-logo-square.svg',
                STYLESHEET_URL: 'https://crossmark-cdn.crossref.org/widget/v2.0/style.css',
            };

            var touchStarted = false;
            var touchArea;
            var tapEvent = function (element, callback) {
                element.addEventListener(
                    'click',
                    function (event) {
                        if (event.ctrlKey || event.shiftKey || event.metaKey || event.which !== 1) {
                            return;
                        }
                        return callback(event);
                    },
                    false
                );

                element.addEventListener(
                    'touchstart',
                    function (event) {
                        if (event.touches.length > 1) return (touchStarted = false);
                        touchArea = {x: event.touches[0].screenX, y: event.touches[0].screenY};
                        touchStarted = element;

                        event.stopPropagation();
                    },
                    false
                );

                window.addEventListener('touchstart', function (event) {
                    touchStarted = false;
                });

                element.addEventListener(
                    'touchmove',
                    function (event) {
                        if (event.touches.length > 1) return (touchStarted = false);
                        const newTouchArea = {x: event.touches[0].screenX, y: event.touches[0].screenY};
                        if (
                            Math.pow(touchArea.x - newTouchArea.x, 2) + Math.pow(touchArea.y - newTouchArea.y, 2) >
                            500
                        ) {
                            touchStarted = false;
                        }
                    },
                    false
                );

                element.addEventListener(
                    'touchend',
                    function (event) {
                        if (touchStarted) {
                            touchStarted = false;
                            return callback(event);
                        } else {
                            event.preventDefault();
                        }
                    },
                    false
                );
            };

            const buildQueryString = function (data) {
                const query = [];
                for (let key in data) {
                    query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
                }
                return '?' + query.join('&');
            };

            const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            // Scan for case-insensitive.
            const getDoiMeta = function () {
                const metaTags = document.querySelectorAll('meta');
                for (let i in metaTags) {
                    if (Object.prototype.hasOwnProperty.call(metaTags, i)) {
                        const tag = metaTags[i];
                        if ((tag.name || '').toLowerCase() === 'dc.identifier' && tag.scheme === 'doi') {
                            return tag;
                        }
                    }
                }
            };

            const doiMeta = getDoiMeta();
            let doi = doiMeta ? doiMeta.getAttribute('content').replace(/^(info:doi\/|doi:)/, '') : null;
            if (doi == null) doi = $('#crossMark').data('doi');

            const queryData = {
                doi: doi,
                domain: window.location.hostname,
                uri_scheme: window.location.protocol,
                cm_version: SETTINGS.SCRIPT_VERSION,
            };

            const css = document.createElement('link');
            css.setAttribute('href', SETTINGS.STYLESHEET_URL);
            css.setAttribute('type', 'text/css');
            css.setAttribute('rel', 'stylesheet');
            document.querySelector('head').appendChild(css);

            const widget = document.createElement('div');
            widget.setAttribute('id', 'crossmark-widget');

            // Initial display none to avoid a flash on load.
            widget.style.display = 'none';

            widget.innerHTML =
                '<div class="crossmark-reset crossmark-overlay"></div>' +
                '<div class="crossmark-reset crossmark-popup">' +
                '<div class="crossmark-reset crossmark-popup__offset">' +
                '<div class="crossmark-reset crossmark-popup__inner">' +
                '<div class="crossmark-reset crossmark-popup__header">' +
                '<button class="crossmark-reset crossmark-popup__btn-close"><span class="sr-only">Close crossmark popup</span></button>' +
                '</div>' +
                '<div class="crossmark-reset crossmark-popup__content-wrapper">' +
                '<iframe title="Crossmark service - Intentionally blank" aria-hidden="true" class="crossmark-reset crossmark-popup__content"></iframe>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';

            const overlay = widget.querySelector('.crossmark-overlay');
            const popup = widget.querySelector('.crossmark-popup');
            const popupOffset = widget.querySelector('.crossmark-popup__offset');
            const popupInner = widget.querySelector('.crossmark-popup__inner');
            const content = widget.querySelector('.crossmark-popup__content');
            const closeButton = widget.querySelector('.crossmark-popup__btn-close');

            if (isIos) popupOffset.classList.add('is-ios');
            // logo.setAttribute('src', SETTINGS.LOGO_URL);

            document.body.appendChild(widget);

            [overlay, popup, closeButton].map(function (element) {
                tapEvent(element, function (event) {
                    widget.style.display = 'none';

                    event.preventDefault();
                    event.stopPropagation();
                });
            });

            tapEvent(popupInner, function (event) {
                event.stopPropagation();
            });

            let initialised = false;

            // delete queryData.domain;

            const links = [].slice.call(document.querySelectorAll('[data-target=crossmark]'), 0);
            links.map(function (link) {
                link.style.cursor = 'pointer';
                link.setAttribute('href', SETTINGS.ENDPOINT + buildQueryString(queryData));

                tapEvent(link, function (event) {
                    if (!initialised) {
                        content.setAttribute('src', SETTINGS.ENDPOINT + buildQueryString(queryData));
                        initialised = true;
                    }
                    widget.style.display = 'block';
                    if (isIos) popupInner.style.top = window.scrollY + 'px';

                    event.preventDefault();
                    event.stopPropagation();
                });
            });
        },
    };
    UX.initCrossref = initCrossref; // add to global namespace
})();

if (document.readyState !== 'loading') {
    UX.initCrossref.init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        UX.initCrossref.init();
    });
}
